export default __webpack_public_path__ + "static/media/matrixQueLg.684f9f4b.png";